import {
  BackSide,
  Mesh,
  MeshBasicMaterialParameters,
  Object3D,
  SphereGeometry,
} from 'three';
import { H3BasicMaterial } from '../../materials/basic/h3-basic-material';

export class OutlinedSphere extends Object3D {
  private sphere: Mesh<SphereGeometry, H3BasicMaterial>;

  constructor(radius: number, options?: MeshBasicMaterialParameters) {
    super();
    const materialsParameters = getOutlinedSphereMaterialParameters(options);
    const sphereGeometry = new SphereGeometry(radius, 32, 16);

    this.sphere = new Mesh(
      sphereGeometry,
      new H3BasicMaterial(materialsParameters.sphere),
    );
    this.sphere.name = 'InnerSphere';

    this.add(this.sphere);

    this.userData = { meshType: 'OutlinedSphere' };
  }

  setMaterial(sphereMaterial: H3BasicMaterial) {
    this.sphere.material = sphereMaterial;
  }

  // Object3D is not raycastable, so we need to keep the raycasting data in the
  // inner mesh children
  setUserData(userData: Object3D['userData']) {
    const newUserData = {
      ...this.userData,
      ...userData,
    };
    this.userData = newUserData;
    this.sphere.userData = newUserData;
  }

  dispose() {
    this.sphere.geometry.dispose();
  }
}

export function getOutlinedSphereMaterialParameters(
  options: MeshBasicMaterialParameters = { opacity: 0.6 },
) {
  const sphere: MeshBasicMaterialParameters = {
    ...options,
    side: BackSide,
    transparent: true,
  };

  const outline: MeshBasicMaterialParameters = {
    ...options,
    opacity: 1,
    side: BackSide,
    transparent: true,
    name: options.name
      ? `${options.name}OutlinedSphereOutline`
      : 'OutlinedSphereOutline',
  };

  return { sphere, outline };
}

export function isOutlinedSphere(object: Object3D): object is OutlinedSphere {
  return object instanceof OutlinedSphere;
}
